import UserAvatarPlaceholder from "@/assets/images/user_avatar_placeholder.svg";
import {useUserPermission} from "@/hooks/useUserHooks";
import type {TFloatingBuyouts} from "@/store/types";
import useUserStore from "@/store/user";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const RequestMoreContent: FC<{type: TFloatingBuyouts}> = ({type}) => {
  const {t} = useTranslation(["payments", "multi_account"]);
  const user = useUserStore(state => state.user);
  const userPermission = useUserPermission();

  return (
    <>
      <div className="border-neutral-grey-lightest flex flex-row items-center justify-between gap-2 rounded-full border-2 p-1">
        <div className="flex items-center gap-1">
          <div className="border-neutral-grey-light-dark size-6 shrink-0 rounded-full border">
            <img
              src={user.profile_picture ?? UserAvatarPlaceholder}
              className="h-full w-full rounded-full object-fill"
            />
          </div>
          <span className="bg-linear-(--primary-dark-gradient) bg-clip-text font-semibold text-transparent">
            {user.first_name}
          </span>
        </div>
        <span className="text-neutral-black text-xs text-nowrap">
          {t(
            `multi_account:${(userPermission === "REFLUENCED_COMPANY_ADMIN" ? "ADMIN" : userPermission).toLowerCase() as "write"}_permissions`,
          )}
        </span>
      </div>
      <div className="text-sm">{t("payments:request_more_description", {type})}</div>
    </>
  );
};

export default RequestMoreContent;
